import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import "./ApplicationAwardUpdate.scss";
import CTAButton from '../CTAButton/CTAButton';
import Field from '../../Components/Field/Field';
import { MAIN_CONFIG } from '../../../config/main';
import Close from '../SVG/Close';
import { handleKeyDown } from '../../Utility/ApplicationFormUtility';

const ApplicationAwardUpdate = ({ application, handleClose = () => { }, onSubmit = () => { }, showSelectedCount = false, numSelected }) => {

  const [currentAwardAmount, setCurrentAwardAmount] = useState(application?.award_amount__c || '');
  const [awardAmountNotes, setAwardAmountNotes] = useState(application?.award_amount_notes__c || '');

  const removeCommaFromAmount = (amount) => {
    return amount && amount.toString().indexOf(",") !== -1 ? amount.split(',').join('') : amount;
  }

  const handleSubmit = () => {
    const formattedAmount = removeCommaFromAmount(currentAwardAmount);
    const data = showSelectedCount ?
      [formattedAmount, awardAmountNotes] :
      [application.sfid, formattedAmount, application?.scholarship__c, awardAmountNotes];

    onSubmit(...data);
  }
  /**
   * Adds the modal content and shows the modal.
   */
  return (
    <div className="update-status-page">
      <div className="update-status-page__header">
        <div>
          <h1 className='H1DesktopGreen update-status-title'>{application?.award_amount__c ? "Edit Award Amount" : "Add Award Amount"}</h1>
        </div>
        <div>
          <button onKeyDown={(e)=>handleKeyDown(e,()=>handleClose())} aria-label='Close Modal' className="event-head H6DesktopGrey close-btn" onClick={handleClose}><Close color={MAIN_CONFIG.COLORS.fillGreen} ariaLabel="Close Modal Button" ariaLabelDescription='' tabIndex={-1}/></button>
        </div>
      </div>
      {showSelectedCount && <div className='BodyDefaultBoldBlack'>{numSelected} {`${numSelected == 1 ? 'Application' : 'Applications'} Selected`}</div>}
      <div className="update-status-page__content">
        <Field
          className='field-group__field-full'
          type='money'
          label='Award Amount'
          placeholder='Award Amount'
          value={currentAwardAmount}
          handleChange={(val) => setCurrentAwardAmount(val)}
        />
         <Field
          className='field-group__field-full'
          type='text'
          label='Award Description (optional)'
          placeholder='Award Description'
          value={awardAmountNotes}
          handleChange={(val) => setAwardAmountNotes(val)}
        />
      </div>
      <div className="update-status-page__footer">
        <div className="footer-short-description">
          <p className="CTAGrey">Please note, the award amount will display to the applicant once their application status is winner or selected. Award Description text is visible under any status.</p>
        </div>

        <div className="footer-button-section">
          <CTAButton id='award-page__cta__cancel' type='inverse' outline onClick={handleClose}>
            Cancel
          </CTAButton>
          <CTAButton id='award-page__cta' type='tertiary' onClick={handleSubmit}>
            Submit
          </CTAButton>
        </div>

      </div>
    </div>
  )
}
// Define PropTypes
ApplicationAwardUpdate.propTypes = {
  application: PropTypes.object,
  handleClose: PropTypes.func,
  onSubmit: PropTypes.func,
  showSelectedCount: PropTypes.bool,
  numSelected: PropTypes.any
};

export default ApplicationAwardUpdate;